import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { TaskStoreModule } from './store/task/task.module'
import { TaskAccessStoreModule } from './store/task-access/module'

const modules = [
  //
  TaskStoreModule,
  TaskAccessStoreModule,
]

@NgModule({
  imports: [CommonModule, ...modules],
  exports: [...modules],
})
export class TasksLibModule {}
